/**
 * Палитра ленты выгод корзины: у каждой карточки свой тон.
 *
 * Раньше цвет означал состояние: достигнутая цель перекрашивалась в зелёный.
 * В итоге «минимум достигнут», «доставка бесплатна» и подарок за частоту
 * оказывались втроём одного цвета, и лента читалась как один длинный блок.
 * Теперь цвет означает МЕХАНИКУ и не меняется, а достижение видно по тексту,
 * по замкнутому кольцу прогресса и по переезду карточки в хвост ленты.
 *
 * Тона разведены по кругу примерно на 60–80°, чтобы соседние слайды не сливались:
 * янтарный 38° → изумрудный 160° → синий 217° → фуксия 292°.
 *
 * Значение — каналы RGB без обёртки: карточка подмешивает из них и фон, и рамку,
 * и кольцо прогресса через `rgb(var(--benefit-tone) / <alpha>)`.
 */
export const BENEFIT_TONES = {
  /** Минимальная сумма заказа — янтарный. */
  minimum: '245 158 11',
  /** Бесплатная доставка — синий. */
  delivery: '59 130 246',
  /** Подарок за сумму заказа — фуксия. */
  giftTier: '217 70 239',
  /** Подарок за частоту заказов — изумрудный. */
  weeklyGift: '16 185 129',
  /** Бесплатной доставки в зоне нет — цели нет, тон нейтральный. */
  unavailable: '148 163 184',
} as const

export type BenefitTone = (typeof BENEFIT_TONES)[keyof typeof BENEFIT_TONES]
